import '../Table/table.css';

import { useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { FiSearch, FiEdit, FiEdit2, FiXCircle, FiDelete, FiTrash2 } from 'react-icons/fi';
// import { RiDeleteBin2Line } from 'react-icons/ri';

const Tabela = ({entidade, dados, elementos, handleSort, sortedId, ordem, urlBase, codigoBase, nomeBase, indice }) => {
  const { perfilUsuario, permissoes } = useContext(AuthContext);
  const navegar = useNavigate();
  const irPara = (sufixo, parametro) => navegar(`${urlBase}${sufixo}${parametro}`, {state: {indice: indice}});
  const renderArrow = () => (ordem === 'asc' ? <FaArrowDown /> : <FaArrowUp />); 

  const renderHeader = () => {
    return elementos.map((item, index) => {
      return (
        <th key={index} className='px-4 py-3 text-sm font-semibold text-gray-700 uppercase tracking-wider' onClick={() => {handleSort(item.coluna)}}>
          <div align="center" className='flex align-items-center'>
            {item.cabecalho} {sortedId === item.coluna && renderArrow()}
          </div>          
        </th>
      )
    })
  }

  const renderData = () => {
    return dados.map((item, index) => {
      return (
        <tr className='linhatabela' key={index}>
          {Object.values(item).map((valor, Colindex) => {
            return (
              <td className={elementos[Colindex].alinhamento}>{valor}</td>
            )
          })}

          <td data-label="Ação" className='tdacao'>
            {entidade === 'Desvios' && (
              <button className='action' onClick={()=> irPara("/consulta/", `${item.cod_desvio}`)}>
                <FiSearch color='green' size={15} /> 
              </button>
            )}

            {entidade === 'Fluidos' && (
              <button className='action' onClick={()=> irPara("/consulta/", `${item.cod_fluido}`)}>
                <FiSearch size={15} /> 
              </button>
            )}

            {entidade === 'Equipamentos' && (
              <button className='action' onClick={()=> irPara("/consulta/", `${item.cod_equipamento}`)}>
                <FiSearch size={15} /> 
              </button>
            )}

            {entidade === 'Compartimentos' && (
              <button className='action' onClick={()=> irPara("/consulta/", `${nomeBase}/${codigoBase}/${item.cod_compartimento}`)}>
                <FiSearch size={15} /> 
              </button>
            )}

            {entidade === 'Ordens' && (
              <button className='action' onClick={()=> irPara("/consulta/", `${item.cod_ordmanutencao}`)}>
                <FiSearch size={15} /> 
              </button>
            )}
            {(entidade === 'Desvios' && permissoes.includes("DESVIO_ALTERAR")) && (
              <button className='text-blue-600 hover:text-blue-800' onClick={()=> irPara("/alteracao/", `${item.cod_desvio}`)}>
                <FiEdit color='blue' size={16} /> 
              </button>
            )}
            {(entidade === 'Desvios' && permissoes.includes("DESVIO_EXCLUIR")) && (
              <button className='text-red-600 hover:text-red-800' onClick={()=> irPara("/exclusao/", `${item.cod_desvio}`)}>
                <FiTrash2 color='red' size={16} /> 
              </button>
            )}

            {(entidade === 'Fluidos' && permissoes.includes("FLUIDO_ALTERAR")) && (
              <button className='action' onClick={()=> irPara("/alteracao/", `${item.cod_fluido}`)}>
                <FiEdit size={16} /> 
              </button>
            )}
            {(entidade === 'Fluidos' && permissoes.includes("FLUIDO_EXCLUIR")) && (
              <button className='action' onClick={()=> irPara("/exclusao/", `${item.cod_fluido}`)}>
                <FiTrash2 size={16} /> 
              </button>
            )}

            {(entidade === 'Equipamentos' && permissoes.includes("EQUIPAMENTO_ALTERAR")) && (
              <button className='action' onClick={()=> irPara("/alteracao/", `${item.cod_equipamento}`)}>
                <FiEdit size={16} /> 
              </button>
            )}
            {(entidade === 'Equipamentos' && permissoes.includes("EQUIPAMENTO_EXCLUIR")) && (
              <button className='action' onClick={()=> irPara("/exclusao/", `${item.cod_equipamento}`)}>
                <FiTrash2 size={16} /> 
              </button>
            )}

            {(entidade === 'Compartimentos' && permissoes.includes("COMPARTIMENTO_ALTERAR")) && (
              <button className='action' onClick={()=> irPara("/alteracao/", `${nomeBase}/${codigoBase}/${item.cod_compartimento}`)}>
                <FiEdit size={15} /> 
              </button>
            )}
            {(entidade === 'Compartimentos' && permissoes.includes("COMPARTIMENTO_EXCLUIR")) && (
              <button className='action' onClick={()=> irPara("/exclusao/", `${nomeBase}/${codigoBase}/${item.cod_compartimento}`)}>
                <FiTrash2 size={15} /> 
              </button>
            )}

            {(entidade === 'Ordens' && permissoes.includes("ORDEM_ALTERAR")) && (
              <button className='action' onClick={()=> irPara("/alteracao/", `${item.cod_ordmanutencao}`)}>
                <FiEdit size={16} /> 
              </button>
            )}
            {(entidade === 'Ordens' && permissoes.includes("ORDEM_EXCLUIR")) && (
              <button className='action' onClick={()=> irPara("/exclusao/", `${item.cod_ordmanutencao}`)}>
                <FiTrash2 size={16} /> 
              </button>
            )}
          </td>
        </tr>
      )
    })
  }

  return ( 
      <div className='overflow-x-auto rounded-lg shadow'>
        <table className='min-w-full divide-y divide-gray-200 bg-white'>
          <thead className='bg-gray-100'>
            <tr>
              { renderHeader() }
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-100'>
              { renderData() }
          </tbody>
          <tfoot className='rodapetabela'>
          </tfoot>
        </table>
      </div>
  )
}
export default Tabela;